export default __webpack_public_path__ + "static/icon_secure.5020521cff39d9db8c0701c41947572a.png";